import React from 'react'
import {PIMStack} from '../../../Atoms/Layouts/Bases/PIMStack'
import {MBContentBodyDivider} from '../../../Atoms/Dividers'
import {AddressConfirms} from './AddressConfirms'
import {MBContentBodyTypography, MBContentSubTitleTypography} from '../../../Atoms/Typographies'
import {PhoneInformation} from '../../../../Utils/Validations/PhoneInformation'
import {ContactAddress} from '../../../../DTO/MemberAddressDTO'

export const ContactAddressConfirmContents: React.VFC<ContactAddress> = (
  {
    postCode,
    addressPrefectureCode,
    addressCity,
    addressStreet,
    addressBuilding,
    phoneMobile,
    phoneTel,
  },
): JSX.Element => (
  <PIMStack spacing={'18px'} divider={<MBContentBodyDivider/>} showEndDivider>
    <AddressConfirms
      postCode={postCode}
      addressPrefectureCode={addressPrefectureCode}
      addressCity={addressCity}
      addressStreet={addressStreet}
      addressBuilding={addressBuilding}
    />
    <div data-testid={'confirm-content-phone'}>
      <PIMStack spacing={'10px'}>
        <MBContentSubTitleTypography>電話番号</MBContentSubTitleTypography>
        <div>
          <MBContentBodyTypography>
            <PhoneInformation mobile={phoneMobile} home={phoneTel}/>
          </MBContentBodyTypography>
        </div>
      </PIMStack>
    </div>
  </PIMStack>
)
